import { TagProps } from '@chakra-ui/react';
import { StatusInfo, StatusInfoKind } from './statusModel';
import { StatusProps } from './statusProps';

function getColorScheme(status: StatusInfo): TagProps['colorScheme'] {
    const mapping = {
        info: 'blue',
        warning: 'orange',
        error: 'red',
        success: 'green',
    } satisfies Record<StatusInfoKind, Required<TagProps>['colorScheme']>;
    return mapping[status.kind];
}

export function buildStatusProps(status: StatusInfo): StatusProps {
    return {
        ...status,
        description: status.description ?? undefined,
        getTagProps() {
            return {
                colorScheme: getColorScheme(status),
                children: status.label,
            };
        },
        getTooltipProps() {
            return {
                isDisabled: status.description === null,
                label: status.description,
            };
        },
    };
}
